import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthActions } from './auth.actions';
import { filter, interval, map, switchMap, tap, takeUntil } from 'rxjs';
import { AuthService } from '../../features/login/services/auth';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectUser } from './auth.selectors';
import { principalRoute, principalRouteNavigate } from '../../shared/utilities/const/route';

@Injectable()
export class AuthEffects {
  private authService = inject(AuthService);
  private actions$ = inject(Actions);
  private store = inject(Store);
  private router = inject(Router);

  loginSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.loginSuccess),
        tap((action) => {
          this.authService.hasLoggedOnce = true;
          console.log('LOGIN SUCCESS -->', action);
        }),
      ),
    { dispatch: false },
  );

  logout = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.logout),
        tap((action) => {
          console.log('LOGOUT -->', action);
          this.authService.logout(action.spid);
          this.router.navigateByUrl('');
        }),
      ),
    { dispatch: false },
  );

  checkSession$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.checkSession),
      switchMap(() =>
        this.authService.userMe().pipe(
          filter((user) => !!user), // Evita di rilanciare azioni inutili
          map((user) => AuthActions.loginSuccess(user)),
        ),
      ),
    ),
  );

  keepAlive$ = createEffect(
    () =>
      this.store.select(selectUser).pipe(
        filter((user) => !!user),
        switchMap(() =>
          interval(10 * 60 * 1000).pipe(
            switchMap(() => this.authService.userMe()),
            takeUntil(this.actions$.pipe(ofType(AuthActions.logout))),
          ),
        ),
      ),
    { dispatch: false },
  );
}
